import { createAction } from 'redux-act';
// add addPolicyCategory action
const createPolicyCategoryRequest = createAction('ADD_POLICY_CATEGORY_REQUEST', data => data);
const createPolicyCategorySuccess = createAction('ADD_POLICY_CATEGORY_SUCCESS', data => data);
const createPolicyCategoryError = createAction('ADD_POLICY_CATEGORY_ERROR');

// Get PolicyCategory action
const getAllPolicyCategorysRequest = createAction('GET_ALL_POLICY_CATEGORYS_REQUEST', data => data);
const getAllPolicyCategorysSuccess = createAction('GET_ALL_POLICY_CATEGORYS_SUCCESS', data => data);
const getAllPolicyCategorysError = createAction('GET_ALL_POLICY_CATEGORYS_ERROR');

//Update PolicyCategory action
const updatePolicyCategoryRequest = createAction('UPDATE_POLICY_CATEGORY_REQUEST', data => data);
const updatePolicyCategorySuccess = createAction('UPDATE_POLICY_CATEGORY_SUCCESS', data => data);
const updatePolicyCategoryError = createAction('UPDATE_POLICY_CATEGORY_ERROR');


// Delete PolicyCategory action
const deletePolicyCategoryRequest = createAction('DELETE_POLICY_CATEGORY_REQUEST', data => data);
const deletePolicyCategorySuccess = createAction('DELETE_POLICY_CATEGORY_SUCCESS', data => data);
const deletePolicyCategoryError = createAction('DELETE_POLICY_CATEGORY_ERROR');

// Get AllPolicy action
const getAllPolicyRequest = createAction('GET_ALL_POLICY_REQUEST', data => data);
const getAllPolicySuccess = createAction('GET_ALL_POLICY_SUCCESS', data => data);
const getAllPolicyError = createAction('GET_ALL_POLICY_ERROR');

//Get PolicyByCategoryId action
const getPolicyByCategoryIdRequest = createAction('GET_POLICY_BY_CATEGORY_ID_REQUEST', data => data);
const getPolicyByCategoryIdSuccess = createAction('GET_POLICY_BY_CATEGORY_ID_SUCCESS', data => data);
const getPolicyByCategoryIdError = createAction('GET_POLICY_BY_CATEGORY_ID_ERROR');

// Update Policy action
const updatePolicyRequest = createAction('UPDATE_POLICY_REQUEST', data => data);
const updatePolicySuccess = createAction('UPDATE_POLICY_SUCCESS', data => data);
const updatePolicyError = createAction('UPDATE_POLICY_ERROR');

// Add Policy action
const createPolicyRequest = createAction('ADD_POLICY_REQUEST', data => data);
const createPolicySuccess = createAction('ADD_POLICY_SUCCESS', data => data);
const createPolicyError = createAction('ADD_POLICY_ERROR');

// Delete Policy action
const deletePolicyRequest = createAction('DELETE_POLICY_REQUEST', data => data);
const deletePolicySuccess = createAction('DELETE_POLICY_SUCCESS', data => data);
const deletePolicyError = createAction('DELETE_POLICY_ERROR');


// Delete acceptPolicyByUser action
const acceptPolicyByUserRequest = createAction('ACCEPT_POLICY_BY_USER_REQUEST', data => data);
const acceptPolicyByUserSuccess = createAction('ACCEPT_POLICY_BY_USER_SUCCESS', data => data);
const acceptPolicyByUserError = createAction('ACCEPT_POLICY_BY_USER_ERROR');


//Get Policy Category List action
const getPolicyCategoryListRequest = createAction('GET_POLICY_CATEGORY_LIST_REQUEST', data => data);
const getPolicyCategoryListSuccess = createAction('GET_POLICY_CATEGORY_LIST_SUCCESS', data => data);
const getPolicyCategoryListError = createAction('GET_POLICY_CATEGORY_LIST_ERROR');

//Get Policy List action
const getPolicyListRequest = createAction('GET_POLICY_LIST_REQUEST', data => data);
const getPolicyListSuccess = createAction('GET_POLICY_LIST_SUCCESS', data => data);
const getPolicyListError = createAction('GET_POLICY_LIST_ERROR');

//Get Policy List action
const getClientTermsAndConditionsRequest = createAction('GET_CLIENT_TERMS_AND_CONDITIONS_REQUEST', data => data);
const getClientTermsAndConditionsSuccess = createAction('GET_CLIENT_TERMS_AND_CONDITIONS_SUCCESS', data => data);
const getClientTermsAndConditionsError = createAction('GET_CLIENT_TERMS_AND_CONDITIONS_ERROR');

//send Otp Verification
const sendOtpVerificationRequest = createAction('SEND_OTP_VERIFICATION_REQUEST', data => data);
const sendOtpVerificationSuccess = createAction('SEND_OTP_VERIFICATION_SUCCESS', data => data);
const sendOtpVerificationError = createAction('SEND_OTP_VERIFICATION_ERROR');

//verify Client Terms OTP action 
const verifyClientTermsOTPRequest = createAction('VERIFY_CLIENT_TERMS_OTP_REQUEST', data => data);
const verifyClientTermsOTPSuccess = createAction('VERIFY_CLIENT_TERMS_OTP_SUCCESS', data => data);
const verifyClientTermsOTPError = createAction('VERIFY_CLIENT_TERMS_OTP_ERROR');

//accept And  Reject Client Terms action 
const acceptAndRejectClientTermsRequest = createAction('ACCEPT_AND_REJECT_CLIENT_TERMS_REQUEST', data => data);
const acceptAndRejectClientTermsSuccess = createAction('ACCEPT_AND_REJECT_CLIENT_TERMS_SUCCESS', data => data);
const acceptAndRejectClientTermsError = createAction('ACCEPT_AND_REJECT_CLIENT_TERMS_ERROR');

// clear existing Department action
const handleClearPolicyStore = createAction('HANDLE_CLEAR_CATEGORY_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    createPolicyCategoryRequest,
    createPolicyCategorySuccess,
    createPolicyCategoryError,

    getAllPolicyCategorysRequest,
    getAllPolicyCategorysSuccess,
    getAllPolicyCategorysError,

    updatePolicyCategoryRequest,
    updatePolicyCategorySuccess,
    updatePolicyCategoryError,

    deletePolicyCategoryRequest,
    deletePolicyCategorySuccess,
    deletePolicyCategoryError,

    createPolicyRequest,
    createPolicySuccess,
    createPolicyError,

    getAllPolicyRequest,
    getAllPolicySuccess,
    getAllPolicyError,

    getPolicyByCategoryIdRequest,
    getPolicyByCategoryIdSuccess,
    getPolicyByCategoryIdError,

    updatePolicyRequest,
    updatePolicySuccess,
    updatePolicyError,

    deletePolicyRequest,
    deletePolicySuccess,
    deletePolicyError,


    acceptPolicyByUserRequest,
    acceptPolicyByUserSuccess,
    acceptPolicyByUserError,

    getPolicyCategoryListRequest,
    getPolicyCategoryListSuccess,
    getPolicyCategoryListError,

    getPolicyListRequest,
    getPolicyListSuccess,
    getPolicyListError,

    getClientTermsAndConditionsRequest,
    getClientTermsAndConditionsSuccess,
    getClientTermsAndConditionsError,

    sendOtpVerificationRequest,
    sendOtpVerificationSuccess,
    sendOtpVerificationError,

    verifyClientTermsOTPRequest,
    verifyClientTermsOTPSuccess,
    verifyClientTermsOTPError,

    acceptAndRejectClientTermsRequest,
    acceptAndRejectClientTermsSuccess,
    acceptAndRejectClientTermsError,

    handleClearPolicyStore,

}